import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { AuthProvider } from './providers/AuthProvider';
import { BrandingProvider } from './providers/BrandingProvider';
import { QueryProvider } from './providers/QueryProvider';
import { ToastContainer } from './components/ui/ToastContainer';
import './index.css';

// Register service worker (PWA) — handled by vite-plugin-pwa

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryProvider>
      <AuthProvider>
        <BrandingProvider>
          <RouterProvider router={router} />
          <ToastContainer />
        </BrandingProvider>
      </AuthProvider>
    </QueryProvider>
  </React.StrictMode>,
);
